import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CricketRanking from '../CricketRanking/CricketRanking';
import LoaderSpinner from '../../../../../components_v2/common/LoaderSpinner/LoaderSpinner';
import Link from '../../../../../components/Link/Link';
import s from './CricketStats.scss';
import CricketStatsCard from './CricketStatsCard';
import { groupData } from './CricketStatsUtils';
import CricketPlayerCard from '../CricketTeamList/CricketPlayerCard';
import { fireGA4Script } from '../../../../../utils/common';

const CricketStats = props => {
  const defaultThumb =
    'https://static.toiimg.com/thumb/msid-81945120,width-100,height-100/81945120.jpg';

  const {
    cricketStats = [],
    default_url = '',
    tournamentName,
    CurrentStatsPage,
  } =
    props.sectionItem || {};
  const TEAM_TEXT = CurrentStatsPage || 'Batting';
  const { deviceType } = props;
  const [activeGroupTab, setActiveGroupTab] = useState(TEAM_TEXT);
  const [cricketStatsData, setCricketStatsData] = useState(
    cricketStats[TEAM_TEXT],
  );
  const [isLoading, setIsLoading] = useState(false);
  const onGroupTabsChange = dataObj => {
    if (dataObj && dataObj?.link && default_url) {
      const rawTab = dataObj.link.toLowerCase();
      const tabMap = {
        team: 'teams',
      };
      const selectedTab = tabMap[rawTab] || rawTab;
      setActiveGroupTab(dataObj?.link);
      const nextDataUrl = `/sports/cricket/${tournamentName}/series-stats/${selectedTab}`;
      window.history.pushState({}, '', nextDataUrl);
      fireGA4Script({ contentType: 'data_page' });
    }
  };
  const thumbslist =
    cricketStats && cricketStats.playerthumbs && cricketStats.playerthumbs.data;
  useEffect(
    () => {
      setIsLoading(true);
      if (
        cricketStats &&
        cricketStats[activeGroupTab] &&
        Array.isArray(cricketStats[activeGroupTab]) &&
        cricketStats[activeGroupTab].length > 0
      ) {
        setCricketStatsData(cricketStats[activeGroupTab]);
        setIsLoading(false);
      }
    },
    [activeGroupTab],
  );
  const dataAvailable =
    cricketStats &&
    cricketStats[activeGroupTab] &&
    Array.isArray(cricketStats[activeGroupTab]) &&
    cricketStats[activeGroupTab].length > 0 &&
    cricketStats[activeGroupTab].every(obj => obj);

  const dataSliceCnt = deviceType ? 2 : 8;
  return (
    <div className="stats_content stats_landing">
      <div className={`${s.team_page} team_page`}>
        {cricketStats &&
          cricketStats.Showcase &&
          Array.isArray(cricketStats.Showcase) &&
          cricketStats.Showcase.length > 0 &&
          cricketStats.Showcase.map(
            top =>
              top && (
                <div className={s.team_players}>
                  <div className={s.team_details_block}>
                    <div className={s.player_bg} />
                    <div className={`${s.top_header} ${s.top_header_align}`}>
                      <i
                        className={
                          top?.stat_id === 13 || top?.stat_id === '13'
                            ? s.top_wickets
                            : s.top_run
                        }
                      />{' '}
                      {top.display_name}
                    </div>
                    <div className={s.players_block}>
                      <div className={s.player_wrap}>
                        {top &&
                          top.leaderboard &&
                          Array.isArray(top.leaderboard) &&
                          top.leaderboard.length > 0 &&
                          top.leaderboard.slice(0, dataSliceCnt).map(items => {
                            const playerkey = items && items.player_name;
                            return (
                              <CricketPlayerCard
                                items={items}
                                playerkey={playerkey}
                                thumbslist={thumbslist}
                                defaultThumb={defaultThumb}
                                statsId={top.stat_id}
                                isIpl={top?.series_id === 13469}
                                tournamentName={tournamentName}
                              />
                            );
                          })}
                      </div>
                    </div>
                  </div>
                  <div className={`${s.seeall} ${s.seeall_mob}`}>
                    <Link
                      to={`/sports/cricket/${tournamentName}/series-stats/${
                        top.stat_id
                      }/${top?.display_name.toLowerCase().replace(' ', '-')}`}
                    >
                      See All
                    </Link>
                  </div>
                </div>
              ),
          )}
      </div>

      {!dataAvailable ? (
        <div className={s.noDataWrapper}>DATA NOT AVAILABLE</div>
      ) : (
        groupData &&
        Array.isArray(groupData) &&
        groupData.length > 0 && (
          <CricketRanking
            groupData={groupData}
            onGroupTabsChange={onGroupTabsChange}
            cricketRanking=""
            currentTab={CurrentStatsPage || groupData[0].name}
            hideTabs=""
          />
        )
      )}
      <div className={s.stats_container}>
        {isLoading && dataAvailable && <LoaderSpinner />}
        {cricketStatsData &&
          Array.isArray(cricketStatsData) &&
          cricketStatsData.length > 0 && (
            <CricketStatsCard
              cricketStatsData={cricketStatsData}
              tournamentName={tournamentName}
            />
          )}
      </div>
    </div>
  );
};
CricketStats.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  deviceType: PropTypes.string,
};
CricketStats.defaultProps = {
  sectionItem: {},
  deviceType: '',
};

export default React.memo(CricketStats);
